// extracted by mini-css-extract-plugin
export default {"video":"YoutubeEmbed_video__HP9FY","iframe":"YoutubeEmbed_iframe__619W+"};